import { render, staticRenderFns } from "./followTopTypeB.vue?vue&type=template&id=7412bf97&scoped=true&"
import script from "./followTopTypeB.vue?vue&type=script&lang=js&"
export * from "./followTopTypeB.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/followTop.css?vue&type=style&index=0&id=7412bf97&lang=css&scoped=true&"
import style1 from "./followTopTypeB.vue?vue&type=style&index=1&id=7412bf97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7412bf97",
  null
  
)

export default component.exports